import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
    Chip,
    Container,
    Grid,
    Stack,
    Typography,
    Tabs,
    Tab,
    Box,
    useMediaQuery,
    Button,
    TextField,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from 'src/components/loader/loader';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

import { styled, useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Breadcrumb } from 'react-bootstrap';
import { ProductList } from 'src/sections/@dashboard/products';
import EmtyData from 'src/components/emty-data';
import ListGroupDevice from './listGroupDevice';
import ListDeviceToAdd from './listDeviceToAdd';
import crypt from 'src/utils/service/crypt';
import ItemAdd from './itemAdd';
import NoteComponents from './noteComponents';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const ARR_ACION = {
    'borrow-local': { key: 'rorrowing_device', type: '0' },
    'take-local': { key: 'getting_device', type: '1' },
    'take-online': { key: 'lay_online', type: '1' },
    'borrow-online': { key: 'muon_online', type: '0' },
    'manager-devices': { key: 'nhap_xuat_tb', type: 'all' },
    tra_thiet_bi: { key: 'tra_thiet_bi', type: 'all' },
};

const AddDevices = ({ visible = false, setVisible, callBack, dataCreateNew, setDataCreateNew }) => {
    const params = useParams();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();
    const [note, setNote] = useState('');

    const [activeTab, setActiveTab] = useState(0); // 0: Lấy, 1: Mượn
    const [tableData, setTableData] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [getFlags, setGetFlags] = useState(false);
    const [data, setData] = useState(null);
    const [dataDrawer, setDataDrawer] = useState([]);
    const [valueDrawer, setValueDrawer] = useState(null);
    const [visibleCabinet, setVisibleCabinet] = useState(false);
    const [valueCabinet, setValueCabinet] = useState(null);
    const [arrProperties, setArrProperties] = useState([]);
    const [dataCabinet, setDataCabinet] = useState([]);

    const actionRef = useRef({ key: '', type: 'all' });
    const getRef = useRef(false);
    const cabinetRef = useRef();
    const getCabinetFlags = useRef(false);
    const insertFlags = useRef(false);
    const user = useRef({});

    const path = window.location.pathname;

    useEffect(() => {
        insertFlags.current = false;
        if (dataCreateNew?.length > 0) {
            const dataHash = dataCreateNew.map((ele) => {
                return {
                    device_id: ele.device_id,
                    device_nm: ele.device_nm,
                    device_cd: ele.device_cd,
                    bussiness: ele.bussiness,
                    classify_imp_exp: ele.classify_imp_exp,
                    quantity: ele.qty,
                    cell_id: ele.cell_id,
                    available: ele.qty <= ele.cell_qty,
                    img_device: ele.img_device,
                    pic_device: ele.pic_device,
                    cell_lc: ele.cell_lc,
                    cabinet_nm: ele.cabinet_nm,
                    drawer_nm: ele.drawer_nm,
                    column: ele.column,
                };
            });

            setSelectedProducts(dataHash);
        }
    }, [dataCreateNew, visible]);

    const getDataDrawer = useCallback(
        (id) => {
            if (visible || dataDrawer?.length == 0) {
                sendRequest(
                    serviceList.getAlldrawerSp,
                    [id],
                    (reqInfo, message) => {
                        if ((message['proc_status']?.toString() || '0') === '0') {
                            toast.error('Error: ' + message['proc_message']);
                        } else {
                            setDataDrawer([{ drawer_nm: t('all'), id: 0 }, ...message.proc_data.rows[0].o_1]);
                        }
                    },
                    true,
                    () => {},
                    15000
                );
            }
        },
        [visible]
    );

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        setData(null);
    };

    const handleAddProduct = useCallback(
        (product, quantity) => {
            if (product?.qty < quantity) {
                toast.error(t('warning_category'));
                return;
            }
            setSelectedProducts((prev) => {
                const exist = prev.find((p) => p.cell_id === product.cell_id);

                if (exist) {
                    if (exist.quantity + quantity > product.qty) {
                        toast.error(t('warning_category'));
                        return prev;
                    } else if (
                        (exist.bussiness == 'etk' && activeTab != 0) ||
                        (exist.bussiness == 'ebr' && activeTab != 1)
                    ) {
                        toast.error(
                            exist.bussiness == 'etk' && activeTab != 0
                                ? t('device_is_taking')
                                : t('device_is_borrowing')
                        );
                        return prev;
                    }
                    return prev.map((p) =>
                        p.cell_id === product.cell_id ? { ...p, quantity: p.quantity + quantity } : p
                    );
                } else {
                    return [
                        ...prev,
                        {
                            ...product,
                            quantity: quantity,
                            classify_imp_exp: 'exp',
                            bussiness: activeTab == 0 ? 'etk' : 'ebr',
                            available: true,
                        },
                    ];
                }
            });
        },
        [activeTab, t]
    );

    const handleRemoveProduct = useCallback((device_id) => {
        setSelectedProducts((prev) => prev.filter((p) => p.device_id !== device_id));
    }, []);

    const handleConfirmProducts = () => {
        try {
            if (insertFlags.current) return;
            insertFlags.current = true;
            if (!note) {
                toast.error(t('error.param'));
                insertFlags.current = false;
                return;
            }
            if (!selectedProducts || selectedProducts?.length == 0) {
                toast.error(t('need_add_device'));
                insertFlags.current = false;

                return;
            }

            const check = selectedProducts?.filter((ele) => ele?.available === false);

            if (check?.length > 0) {
                toast.error(t('list_device_have_unavailable'));
                insertFlags.current = false;
                return;
            }
            const listDeviceToAdd = selectedProducts.map((ele) => ({
                device_id: ele.device_id,
                bussiness: ele.bussiness,
                classify_imp_exp: ele.classify_imp_exp,
                quantity: ele.quantity,
                cell_id: ele.cell_id,
            }));
            const InVal = [note, JSON.stringify(listDeviceToAdd)];
            sendRequest(serviceList.addRequestDevice, InVal, handleConfirmProductsResult, true, timeOutFunct, 15000);
        } catch (error) {
            insertFlags.current = false;
        }
    };

    const handleConfirmProductsResult = (reqInfoMap, message) => {
        insertFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setData(null);
            setDataCreateNew([]);
            setSelectedProducts([]);
            setVisible(false);
            setNote('');
            toast.success(message['proc_message']);

            callBack();
        }
    };

    useEffect(() => {
        if (visible || dataCabinet.length == 0) {
            if (glb_sv.userInfo.group_user !== '3') {
                getDataCabinet();
            }
        }
    }, [visible]);

    useEffect(() => {
        try {
            // --- Lấy user ---
            const userData = sessionStorage.getItem('proc_data');
            if (userData) {
                try {
                    user.current = JSON.parse(crypt.deCode(userData));
                } catch {}
            } else {
                user.current = glb_sv.userInfo;
            }

            // --- Lấy cabinet từ localStorage hoặc sessionStorage ---
            let chooseCabinet =
                glb_sv.getLocalStorageCabinet('cabinet') || JSON.parse(sessionStorage.getItem('cabinet') || 'null');

            // Nếu props/state valueCabinet có id thì ưu tiên hơn
            if (valueCabinet?.id !== undefined) {
                chooseCabinet = valueCabinet;
            }

            if (chooseCabinet || visible) {
                cabinetRef.current = chooseCabinet;

                if (chooseCabinet.id === 0) {
                    setDataDrawer([{ drawer_nm: t('all'), id: 0 }]);
                    setValueDrawer(null);
                } else {
                    getDataDrawer(chooseCabinet.id);
                }
            } else {
                setVisibleCabinet(true);
            }
        } catch (error) {
            console.error(error);
        }
    }, [valueCabinet?.id, arrProperties, visible]);

    const getDataCabinet = () => {
        if (visible || dataCabinet?.length == 0) {
            console.log('start get =======================>');
            console.log(getCabinetFlags.current);
            if (getCabinetFlags.current) return;
            getCabinetFlags.current = true;
            const InVal = [];
            sendRequest(serviceList.getAllCabinetSp, InVal, getDataCabinetResult, true, timeOutFunct, 15000);
        }
    };

    const getDataCabinetResult = (reqInfoMap, message) => {
        getCabinetFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataCabinet([{ cabinet_nm: t('all'), id: 0 }, ...message.proc_data.rows[0].o_1]);
            setDataDrawer([{ drawer_nm: t('all'), id: 0 }]);

            console.log('ned get =======================>');
        }
    };

    useEffect(() => {
        try {
            const getSessions = sessionStorage.getItem('cabinet');
            if (getSessions) {
                const ssCabinet = JSON.parse(getSessions);
                cabinetRef.current = ssCabinet;
                getDataDrawer(ssCabinet.id);
            }
        } catch (error) {}
        if (visible) {
            if (valueCabinet?.id && valueCabinet?.id !== 0) {
                getData(valueCabinet.id, valueDrawer?.id ? valueDrawer.id : null);
            }
            if (valueCabinet?.id === 0) {
                glb_sv.userInfo.group_user !== '3' && getData();
                setValueDrawer(null);
                setDataDrawer([{ drawer_nm: t('all'), id: 0 }]);
            }
            if (!valueCabinet?.id && valueDrawer?.id !== 0) {
                getData(cabinetRef.current?.id ? cabinetRef.current?.id : 0, valueDrawer?.id);
            }
        }
    }, [valueCabinet?.id, valueDrawer?.id, arrProperties, visible]);

    useEffect(() => {
        actionRef.current = ARR_ACION[path.split('/')[3]];

        setTimeout(() => {
            setData(null);
            getData();
        }, 1000);
    }, []);

    //get all group device
    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [+params.idPermission, actionRef.current?.type || 'all'];
        sendRequest(serviceList.getAllgroup_devicesUser, InVal, getDataResult, true, timeOutFunct, 15000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1);
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        getCabinetFlags.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    return (
        <BootstrapDialog
            fullScreen={true}
            open={visible}
            aria-labelledby="customized-dialog-title"
            PaperProps={{
                sx: {
                    width: '100%', // desktop 80%
                    maxWidth: '100%', // desktop max 1200px
                    minWidth: '100%', // desktop min 700px
                },
            }}
            slotProps={{
                root: {
                    sx: { zIndex: 1100 }, // modal root
                },
            }}
        >
            <BootstrapDialogTitle
                onClose={() => {
                    setVisible(!visible);
                    setData(null);
                    setSelectedProducts([]);
                    setDataCreateNew([]);
                }}
                id="customized-dialog-title"
            >
                <Typography variant="h4" component="span" sx={{ mb: 2 }}>
                    {activeTab === 0 ? t('getting_device') : t('rorrowing_device')}
                </Typography>

                <Tabs value={activeTab} onChange={handleTabChange}>
                    <Tab label={t('getting_device')} />
                    <Tab label={t('rorrowing_device')} />
                </Tabs>
            </BootstrapDialogTitle>
            <Helmet>
                <title>{activeTab === 0 ? t('getting_device') : t('rorrowing_device')}</title>
            </Helmet>
            <DialogContent sx={{ overflow: 'auto' }}>
                <Loader loading={getFlags} />
                <Stack direction="row" spacing={2} mt={2}>
                    {/* Left: Product Grid */}
                    <Box flex={3}>
                        <Breadcrumb paths={[{ label: t('choose_group'), url: '#', navigate: false }]} />

                        {/* <Grid container spacing={3}>
                            {tableData.map((product) => (
                                <Grid key={product.device_id} item xs={6} sm={4} md={3} xl={2.4}>
                                    <ProductCard product={product} functOnClick={handleAddProduct} isRegisterOnline />
                                </Grid>
                            ))}
                        </Grid> */}
                        {!data &&
                            (tableData?.length > 0 ? (
                                <ListGroupDevice products={tableData} setData={setData} activeTab={activeTab} />
                            ) : (
                                <EmtyData />
                            ))}

                        {data && (
                            <ListDeviceToAdd
                                idGroup={data.id}
                                setData={setData}
                                handleAddProduct={handleAddProduct}
                                activeTab={activeTab}
                                dataDrawer={dataDrawer}
                                setDataDrawer={setDataDrawer}
                                valueCabinet={valueCabinet}
                                setValueCabinet={setValueCabinet}
                                arrProperties={arrProperties}
                                setArrProperties={setArrProperties}
                                valueDrawer={valueDrawer}
                                setValueDrawer={setValueDrawer}
                                cabinetRef={cabinetRef}
                                user={user}
                                visibleCabinet={visibleCabinet}
                                setVisibleCabinet={setVisibleCabinet}
                                dataCabinet={dataCabinet}
                            />
                        )}
                    </Box>
                    <Box
                        flex={1}
                        sx={{
                            borderLeft: '1px solid #ccc',
                            pl: 2,
                            position: 'sticky',
                            top: 0,
                            height: 'calc(100vh - 180px)',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Typography variant="h6" sx={{ mb: 1 }}>
                            {t('selected_products')}
                        </Typography>

                        <Box
                            sx={{
                                flexGrow: 1,
                                overflowY: 'auto',
                                pr: 1,
                                mb: 2,
                            }}
                        >
                            <Stack spacing={1}>
                                {selectedProducts.map((p) => (
                                    <ItemAdd key={p.device_id} p={p} handleRemoveProduct={handleRemoveProduct} />
                                ))}
                            </Stack>
                        </Box>

                        <Box
                            sx={{
                                borderTop: '1px solid #eee',
                                pt: 2,
                                backgroundColor: '#fff',
                            }}
                        >
                            <Stack spacing={2}>
                                <TextField
                                    label={t('note_')}
                                    value={note}
                                    onChange={(e) => setNote(e.target.value)}
                                    multiline
                                    minRows={2}
                                    fullWidth
                                    required
                                />

                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    size="large"
                                    onClick={handleConfirmProducts}
                                >
                                    {t('confirm')}
                                </Button>
                            </Stack>
                        </Box>
                    </Box>
                </Stack>
            </DialogContent>
        </BootstrapDialog>
    );
};

export default AddDevices;
